import React, { useEffect, useState } from "react";
import { TableContainer, Paper, Typography, Box, Button } from "@mui/material";
import NoDataFound from "../../Components/Masters/NoDataFound";
import PaginationBox from "../../Components/Masters/Pagination";
import { getMonthName } from "../../utils/getMonthName";
import DocFiles from "./DocFiles";
import { fixedPercentage } from "../../utils/common";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { api, put } from "../../utils/api";
import MenuIcon from "../../Components/Masters/MenuIcon";
import ViewDetailsDrawer from "./ViewDetailsDrawer";
import ViewDeletedDrawer from "./ViewDeletedDrawer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";

function TableDocument({
  data,
  totalPages,
  headers,
  page = 1,
  handleChangePage,
  columnWidth,
  tableContainerRef,
  isShortContent,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
  viewcolumnWidth,
  viewheaders,
  stationCombustionView = false,
  viewPage = ViewDetailsDrawer,
}) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [deleteDrawer, setDeleteDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleViewClick = (data) => {
    if (data?.requestStatus === "delete") {
      setDeleteDrawer(true);
      setSelectedData(data);
    } else {
      setDrawerOpen(true);
      setSelectedData(data);
    }
  };

  const ViewPageComponent = viewPage;

  return (
    <Box>
      <TableContainer
        component={Paper}
        ref={tableContainerRef}
        sx={{ maxWidth: "100%" }}
      >
        <Box>
          <Box
            sx={{
              display: "grid",
              // gridTemplateColumns: columnWidth,
              gridTemplateColumns: `${columnWidth} 100px`,
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {headers.map((el) => (
              <Typography
                sx={{
                  height: "100%",
                  fontWeight: "bold",
                  padding: "8px 12px",
                  paddingY: "10px",
                  textAlign: el?.title === "Date" ? "center" : "left",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {el?.title}
              </Typography>
            ))}
            <Typography
              sx={{
                fontWeight: "bold",
                // padding: "8px 12px",
                paddingY: "10px",
                textAlign: "center",
              }}
            >
              Action
            </Typography>
          </Box>
          {data.length === 0 ? (
            <NoDataFound />
          ) : (
            data?.map((item) => (
              <Box
                key={item._id}
                sx={{
                  display: "grid",
                  // gridTemplateColumns: columnWidth,
                  gridTemplateColumns: `${columnWidth} 100px`,
                  borderBottom: "1px solid #ddd",
                }}
              >
                {headers.map((el) => (
                  <Typography
                    sx={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      color: "black",
                      padding: "8px 12px",
                      paddingTop: "1rem",
                    }}
                  >
                    {el?.key === "createdAt" || el?.key === "dateOfTravel" || el?.key === "purchaseDate" || el?.key === "dateOfSale" || el?.key === "soldProductDate"
                      ? new Date(item[el?.key]).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : el?.key === "consumptionPeriod"
                        ? getMonthName(item[el?.key]?.month) +
                          ", " +
                          item[el?.key]?.year
                        : el?.key === "efficiency"
                          ? fixedPercentage(item[el?.key])
                          : el?.key === "equipment"
                            ? item[el?.key]?.equipment
                            : el.key === "vendor"
                              ? item[el.key]?.VendorLegalFullName
                              : el.key === "quantityConsumed"
                                ? item[el.key].value + " " + item[el.key].unit
                                : el.key === "quantityProduced"
                                  ? item[el.key].value + " " + item[el.key].unit
                                  : el.key === "quantityOfWasteGenerated"
                                    ? item[el.key].value +
                                      " " +
                                      item[el.key].unit
                                    : el.key === "purchases"
                                      ? item[el.key].vendorLegalName
                                      : el.key === "quantityOfWasteManaged"
                                        ? item[el.key].value +
                                          " " +
                                          item[el.key].unit
                                        : el.key === "createdBy" &&
                                            item[el.key]?.name
                                          ? item?.createdBy?.name
                                          : typeof item[el.key] === "object" &&
                                              item[el.key]?.[el.field] !==
                                                null &&
                                              item[el.key]?.[el.field]
                                            ? item[el.key][el.field]
                                            : typeof item[el.key] ===
                                                  "object" &&
                                                item[el.key] !== null &&
                                                item[el.key]?.name
                                              ? item[el.key].name
                                              : item[el.key] || el.key || "N/A"}
                  </Typography>
                ))}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    minHeight: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: "primary.main",
                      fontSize: "14px",
                    }}
                    onClick={() => handleViewClick(item)}
                  >
                    View
                  </Typography>
                </Box>
              </Box>
            ))
          )}
        </Box>
      </TableContainer>

      <ViewDeletedDrawer
        open={deleteDrawer}
        onClose={() => setDeleteDrawer(false)}
        data={selectedData}
        setsnackOpen={setsnackOpen}
        fetchDataCallback={fetchDataCallback}
        apiUrl={apiUrl}
        headers={viewheaders}
        columnWidth={viewcolumnWidth}
      />
      {drawerOpen && viewPage}

      {/* {stationCombustionView && (
        <ViewDetailsDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          data={selectedData}
          setsnackOpen={setsnackOpen}
          fetchDataCallback={fetchDataCallback}
          apiUrl={apiUrl}
        />
      )} */}
      {drawerOpen && (
        <ViewPageComponent
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          data={selectedData}
          setsnackOpen={setsnackOpen}
          fetchDataCallback={fetchDataCallback}
          apiUrl={apiUrl}
        />
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <PaginationBox
          isShortContent={isShortContent}
          {...{
            totalPages,
            page,
            handleChangePage,
          }}
        />
      )}
    </Box>
  );
}

export default TableDocument;
